import axiosInstance from "./AxiosInstance";

export function getServiceCenterOptionApi(){
    return axiosInstance.get('/api/search-service-centers')
}

export function getVehicleNumberApi(){
    return axiosInstance.get('/api/vehicles/numbers/')
}

export function getBrandModelApi(){
    return axiosInstance.get('/api/search-vehicle-brands')
}

export function getServiceoption(vehicle_type){
    return axiosInstance.get(`api/search-service-types?vehicle_type=${vehicle_type}`)
}

export function getVehicleTypeUsingModel(model){
    return axiosInstance.get(`/api/vehicle-model-size/${model}`)
}

export function getSearchExpenseCategory(){
    return axiosInstance.get('api/expense-catagory')
}

export function getSearchSubCategoryApi(){
    return axiosInstance.get('api/expense-subcatagory')
}

export function getSearchSubCategoryByCategoryApi(id){
    return axiosInstance.get(`api/subcategories-by-categories/${id}`)
}

export function searchVendorApi(){
    return axiosInstance.get('api/search-vendor')
}

export function getSearchEmployeeWithUser(){
    return axiosInstance.get('api/search-employee-user')
}
export function getDoorStepEmployeeUtilitySearchApi(){
    return axiosInstance.get('api/search-categories')
}